import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { getAvailableRewardTypeOptions, getRewardPoints, getRewardPointsOptions } from '../lib/rewardTypeOptions';
import { getCurrentLanguageKey, getLanguageSection } from '../../../shared/services/languageService';

const darkInputClass = "h-10 w-full rounded-lg border border-white/20 bg-white px-3 text-sm font-bold text-[#151b3f] outline-none transition placeholder:text-slate-400 focus:border-white focus:ring-4 focus:ring-white/15";

function RedeemAwardRow({ index, rewardTypes, onChange, onRemove }) {
  const [redeem, setRedeem] = useState({});

  const language = getLanguageSection('trackredeem');
  const removeRowLabel = (language.awardboxText5 || "").replace(/\s*-\s*$/, '');
  const countryUser = Cookies.get('CountryUser');
  const currentLanguage = getCurrentLanguageKey();

  const handleChange = (event) => {
    const { name, value } = event.target;
    const [, field] = name.split('.');

    const nextRedeem = { ...redeem, [field]: value };

    if (field === 'Id_MarivalRewardType') {
      const points = getRewardPoints(rewardTypes, value);
      nextRedeem.Points = points && Number(points) !== 0 ? points : 0;
    }

    setRedeem(nextRedeem);
    onChange(nextRedeem, index);
  };

  const rewardTypeOptions = getAvailableRewardTypeOptions(rewardTypes, countryUser, currentLanguage);
  const pointsOptions = getRewardPointsOptions(rewardTypes, redeem.Id_MarivalRewardType);

  return (
    <div className={"row_" + index + " rounded-2xl border border-white/15 bg-white/10 p-4"}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-white/10 pb-3">
        <h4 className="m-0 text-sm font-black text-white">{language.awardboxText1}</h4>
        {index > 0 ? (
          <button type="button" className="rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-black text-white transition hover:bg-white/20" onClick={() => onRemove(index)}>
            <span>{removeRowLabel}</span>
          </button>
        ) : null}
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <label className="m-0 block text-[11px] font-black uppercase tracking-wide text-white/80">{language.awardboxText2}</label>
          <select className={darkInputClass} value={redeem.Id_MarivalRewardType} onChange={handleChange} name='redeem.Id_MarivalRewardType'>
            <option key={-1} value="-1">-</option>
            {rewardTypeOptions.map((option, optionIndex) => (
              <option key={optionIndex} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>

        <div className="space-y-2">
          <label className="m-0 block text-[11px] font-black uppercase tracking-wide text-white/80">{language.awardboxText3}</label>
          <select className={darkInputClass} value={redeem.Points} defaultValue="0" onChange={handleChange} name='redeem.Points'>
            {pointsOptions.map((option, optionIndex) => (
              <option key={optionIndex} value={option.value} disabled={option.disabled}>{option.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default RedeemAwardRow;
